import { Box, Typography } from '@mui/material';

function PFNSendAddress() {
  return (
    <Box>
      <Typography mt={2}>〒 100-0004</Typography>
      <Typography>東京都千代田区大手町1-6-1 大手町ビル 地下2階230区</Typography>
      <Typography>株式会社Preferred Networks 3Dスキャン係</Typography>
      <Typography>TEL: 080-7812-0450</Typography>
    </Box>
  );
}

export default PFNSendAddress;
